import styled from 'styled-components'
import get from 'lodash/get'

const getMenuBorder = props => props.theme.select.menu.border
const getMenuColor = props => get(props.theme, 'select.menu.color', 'inherit')
const getMenuBorderTop = props => get(props.theme, 'select.menu.borderTop', 0)
const getMenuMarginTop = props => get(props.theme, 'select.menu.marginTop', 0)

const getFontSize = props => get(props.theme, 'select.menu.option.fontSize', props.theme.font.mobile.size)
const getLineHeight = props => get(props.theme, 'select.menu.option.lineHeight', props.theme.font.mobile.height)
const getFontFamily = props => get(props.theme, 'select.menu.option.fontFamily', 'inherit')

const getMenuListBackgroundColor = props => get(props.theme, 'select.menu.list.backgroundColor', '#FFFFFF')
const getMenuBoxShadow = props =>
  get(props.theme, 'select.autosuggest.menu.boxShadow', '0 2px 4px 0 rgba(0, 0, 0, 0.5)')
const getListMargin = props => get(props.theme, 'select.autosuggest.menu.list.margin', '0')
const getBorderRadiusOnOpen = props => get(props.theme, 'select.autosuggest.open.borderRadius', '0')
const getMenuBorderRadius = props => get(props.theme, 'select.menu.borderRadius', '0')
const getFocusedOptionBackground = props => props.theme.select.menu.option.focusBackground
const getFocusedOptionBorder = props => props.theme.select.menu.option.focusBorder
const getFocusedOptionColor = props => props.theme.select.menu.option.focusColor

const AutosuggestView = styled.div`
  .react-autosuggest__container {
    position: relative;
  }

  .react-autosuggest__container--open input {
    border-radius: ${getBorderRadiusOnOpen};
  }

  .react-autosuggest__suggestions-container {
    display: none;
    position: absolute;
    border: ${getMenuBorder};
    color: ${getMenuColor};
    margin-top: ${getMenuMarginTop};
    border-top: ${getMenuBorderTop};
    z-index: 1;
    left: 0;
    right: 0;
    border-radius: ${getMenuBorderRadius};
    background-color: ${getMenuListBackgroundColor};
    box-shadow: ${getMenuBoxShadow};
  }
  .react-autosuggest__suggestions-container--open {
    display: block;
  }

  .react-autosuggest__suggestions-list {
    margin: ${getListMargin};
    padding: 0;
    max-height: 248px;
    overflow-y: auto;
  }

  .react-autosuggest__suggestion {
    display: block;
    cursor: pointer;
    padding: 4px 16px 4px 16px;
    font-size: ${getFontSize};
    line-height: ${getLineHeight};
    font-family: ${getFontFamily};
  }

  .react-autosuggest__suggestion--focused {
    padding-top: 8px;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: ${getFocusedOptionBackground} !important;
    border: ${getFocusedOptionBorder} !important;
    color: ${getFocusedOptionColor} !important;
  }
`

export {AutosuggestView}
